<script setup lang="ts">
import { WalletConnectStatus } from '@shared/types'
import { Status, StatusType } from '@injectivelabs/utils'
import '@/assets/css/tailwind.css'

const route = useRoute()
const router = useRouter()
const skipStore = useSkipStore()
const tokenStore = useTokenStore()
const walletStore = useWalletStore()
const sharedTokenStore = useSharedTokenStore()
const sharedWalletStore = useSharedWalletStore()

const { $onError } = useNuxtApp()

const status = reactive(new Status(StatusType.Loading))
const jsonStatus = reactive(new Status(StatusType.Loading))

onMounted(() => {
  handleGoogleOAuth()

  walletStore.init()

  status.setLoading()

  Promise.all([
    tokenStore.fetchPeggyTokens(),
    sharedTokenStore.fetchTokensUsdPriceMap(),
    skipStore.fetchChains(),
    skipStore.fetchAssets()
  ])
    .catch($onError)
    .then(() => {
      status.setIdle()
    })
})

function onJsonLoaded() {
  jsonStatus.setIdle()
}

function handleGoogleOAuth() {
  if (sharedWalletStore.isUserConnected) {
    return
  }

  if (!route.hash) {
    return
  }

  const params = new URLSearchParams(route.hash.substring(1))
  const idToken = params.get('id_token')

  if (!idToken) {
    return
  }

  router.replace({ hash: '' })

  sharedWalletStore
    .initTurnkeyGoogle(idToken)
    .catch($onError)
    .finally(() => {
      sharedWalletStore.walletConnectStatus = WalletConnectStatus.idle
    })
}
</script>

<template>
  <UApp>
    <NuxtLayout>
      <div class="flex flex-col flex-1 sm:justify-center items-center">
        <div v-if="status.isLoading() || jsonStatus.isLoading()" class="w-full">
          <UCard class="max-w-xl w-full mx-auto">
            <div class="space-y-8">
              <div>
                <USkeleton class="h-8 w-1/3" />
              </div>

              <div class="grid grid-cols-2 gap-8">
                <USkeleton v-for="i in 4" :key="i" class="h-[78px] w-full" />
              </div>

              <USkeleton
                v-for="i in 3"
                :key="i"
                :class="i === 3 ? 'h-[90px]' : 'h-14'"
              />
            </div>
          </UCard>
        </div>

        <NuxtPage v-else />
      </div>

      <AppJsonPoll @on:loaded="onJsonLoaded" />
    </NuxtLayout>
  </UApp>
</template>
